import NotificationActions from "../../actions/NotificationActions";

class DOB extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid(),
            date : '',
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.isDateInFuture = this.isDateInFuture.bind(this);
    }

    componentDidMount() {
        this.setState({ date : moment(this.props.value).format('YYYY-MM-DD') });
    }

    isDateInFuture(date) {

        if(this.props.AllowInFuture) {
            return false;
        }

        if (moment(date).isAfter(moment())) {
            NotificationActions.error('Date of Birth cannot be in the future.');
            return true;
        } else {
            return false;
        }
    }

    onChange(e) {
        this.setState({ date: e.target.value });
    }

    onBlur() {
        const { date } = this.state;

        if (!moment(date).isValid() || this.isDateInFuture(date)) {
            $('#'+this.state.uuid).addClass('input-text-1__error');
        } else {
            $('#'+this.state.uuid).removeClass('input-text-1__error');
        }

        this.props.onChange(this.props.field, date);
    }

    render() {
        var tabindex = this.props.tabindex || '';
        return (
            <div
                className={'input-profile '+this.props.className}>

                { this.props.title &&
                    <div className='input-profile__title'>
                        {this.props.title}
                    </div>
                }

                <input
                    type='date'
                    value={this.state.date}
                    disabled={this.props.disabled}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    placeholder='MM/DD/YYYY'
                    id={this.state.uuid}
                    tabindex={tabindex} />

            </div>
        );
    }
}

export default DOB;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/DOB.react.jsx